import "./SpecifyingEngineers.module.css";
import Header from "@/reusable_sections/Header";
import PageHeader from "./sections/PageHeader";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import TheSpecifiersProblem from "./sections/TheSpecifiersProblem";
import WhatEvermarkGivesSpecifiers from "./sections/WhatEvermarkGivesSpecifiers";
import WhatSpecifiersSpecify from "./sections/WhatSpecifiersSpecify";
import BasisOfDesignGetSpecifiedByName from "./sections/BasisOfDesignGetSpecifiedByName";
import ScopeResponsibility from "./sections/ScopeResponsibility";
import Faq from "./sections/Faq";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function SpecifyingEngineersPage() {
  return <div>
      <Header />
      <PageHeader />
      <DirectAnswerBlock />
      <TheSpecifiersProblem />
      <WhatEvermarkGivesSpecifiers />
      <BasisOfDesignGetSpecifiedByName />
      <WhatSpecifiersSpecify />
      <ScopeResponsibility />
      <Faq />
      <ClosingCta />
      <Footer />
    </div>;
}